/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTrackCollectionRequest,
  CreateTrackCollectionResponse,
  GetApiV1TrackCollectionsParams,
  GetTrackCollectionKeywordsResponse,
  GetTrackCollectionPageResponse,
  GetTrackCollectionResponse,
  GetTrackCollectionTracksResponse,
  GetTrackCollectionsResponse,
  PatchTrackCollectionRequestBody,
  ProblemDetails,
  PutTrackCollectionKeywordsRequestBody,
  PutTrackCollectionKeywordsResponse,
  PutTrackCollectionTracksRequestBody,
  PutTrackCollectionTracksResponse
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiV1TrackCollections = (
    params: GetApiV1TrackCollectionsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackCollectionsResponse | null>(
      {url: `/api/v1/track-collections`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1TrackCollectionsQueryKey = (params?: GetApiV1TrackCollectionsParams,) => {
    return [
    `/api/v1/track-collections`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1TrackCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError = ProblemDetails | null>(params: GetApiV1TrackCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackCollectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackCollections>>> = ({ signal }) => getApiV1TrackCollections(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackCollections>>>
export type GetApiV1TrackCollectionsQueryError = ProblemDetails | null


export function useGetApiV1TrackCollections<TData = Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackCollectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollections>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollections<TData = Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollections>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollections<TData = Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackCollections<TData = Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1TrackCollections = (
    createTrackCollectionRequestNull: CreateTrackCollectionRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<CreateTrackCollectionResponse | null>(
      {url: `/api/v1/track-collections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTrackCollectionRequestNull, signal
    },
      );
    }




export const getPostApiV1TrackCollectionsMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1TrackCollections>>, TError,{data: CreateTrackCollectionRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1TrackCollections>>, TError,{data: CreateTrackCollectionRequest | null}, TContext> => {

const mutationKey = ['postApiV1TrackCollections'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1TrackCollections>>, {data: CreateTrackCollectionRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1TrackCollections(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1TrackCollectionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1TrackCollections>>>
    export type PostApiV1TrackCollectionsMutationBody = CreateTrackCollectionRequest | null
    export type PostApiV1TrackCollectionsMutationError = ProblemDetails | null

    export const usePostApiV1TrackCollections = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1TrackCollections>>, TError,{data: CreateTrackCollectionRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1TrackCollections>>,
        TError,
        {data: CreateTrackCollectionRequest | null},
        TContext
      > => {
      return useMutation(getPostApiV1TrackCollectionsMutationOptions(options), queryClient);
    }
    export const getApiV1TrackCollectionsId = (
    id: number,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackCollectionResponse | null>(
      {url: `/api/v1/track-collections/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackCollectionsIdQueryKey = (id: number,) => {
    return [
    `/api/v1/track-collections/${id}`
    ] as const;
    }


export const getGetApiV1TrackCollectionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError = ProblemDetails | null>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackCollectionsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>> = ({ signal }) => getApiV1TrackCollectionsId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackCollectionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>>
export type GetApiV1TrackCollectionsIdQueryError = ProblemDetails | null


export function useGetApiV1TrackCollectionsId<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError = ProblemDetails | null>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsId<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsId<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackCollectionsId<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackCollectionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiV1TrackCollectionsId = (
    id: number,
    patchTrackCollectionRequestBodyNull: PatchTrackCollectionRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/track-collections/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTrackCollectionRequestBodyNull, signal
    },
      );
    }




export const getPatchApiV1TrackCollectionsIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1TrackCollectionsId>>, TError,{id: number;data: PatchTrackCollectionRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1TrackCollectionsId>>, TError,{id: number;data: PatchTrackCollectionRequestBody | null}, TContext> => {

const mutationKey = ['patchApiV1TrackCollectionsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1TrackCollectionsId>>, {id: number;data: PatchTrackCollectionRequestBody | null}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiV1TrackCollectionsId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1TrackCollectionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1TrackCollectionsId>>>
    export type PatchApiV1TrackCollectionsIdMutationBody = PatchTrackCollectionRequestBody | null
    export type PatchApiV1TrackCollectionsIdMutationError = ProblemDetails | null

    export const usePatchApiV1TrackCollectionsId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1TrackCollectionsId>>, TError,{id: number;data: PatchTrackCollectionRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1TrackCollectionsId>>,
        TError,
        {id: number;data: PatchTrackCollectionRequestBody | null},
        TContext
      > => {
      return useMutation(getPatchApiV1TrackCollectionsIdMutationOptions(options), queryClient);
    }
    export const getApiV1TrackCollectionsIdTracks = (
    id: number,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackCollectionTracksResponse | null>(
      {url: `/api/v1/track-collections/${id}/tracks`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackCollectionsIdTracksQueryKey = (id: number,) => {
    return [
    `/api/v1/track-collections/${id}/tracks`
    ] as const;
    }


export const getGetApiV1TrackCollectionsIdTracksQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError = ProblemDetails | null>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackCollectionsIdTracksQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>> = ({ signal }) => getApiV1TrackCollectionsIdTracks(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackCollectionsIdTracksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>>
export type GetApiV1TrackCollectionsIdTracksQueryError = ProblemDetails | null


export function useGetApiV1TrackCollectionsIdTracks<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError = ProblemDetails | null>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsIdTracks<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsIdTracks<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackCollectionsIdTracks<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdTracks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackCollectionsIdTracksQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiV1TrackCollectionsIdTracks = (
    id: number,
    putTrackCollectionTracksRequestBodyNull: PutTrackCollectionTracksRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PutTrackCollectionTracksResponse | null>(
      {url: `/api/v1/track-collections/${id}/tracks`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putTrackCollectionTracksRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1TrackCollectionsIdTracksMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdTracks>>, TError,{id: number;data: PutTrackCollectionTracksRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdTracks>>, TError,{id: number;data: PutTrackCollectionTracksRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1TrackCollectionsIdTracks'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdTracks>>, {id: number;data: PutTrackCollectionTracksRequestBody | null}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV1TrackCollectionsIdTracks(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1TrackCollectionsIdTracksMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdTracks>>>
    export type PutApiV1TrackCollectionsIdTracksMutationBody = PutTrackCollectionTracksRequestBody | null
    export type PutApiV1TrackCollectionsIdTracksMutationError = ProblemDetails | null

    export const usePutApiV1TrackCollectionsIdTracks = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdTracks>>, TError,{id: number;data: PutTrackCollectionTracksRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1TrackCollectionsIdTracks>>,
        TError,
        {id: number;data: PutTrackCollectionTracksRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1TrackCollectionsIdTracksMutationOptions(options), queryClient);
    }
    export const getApiV1TrackCollectionsIdKeywords = (
    id: number,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackCollectionKeywordsResponse | null>(
      {url: `/api/v1/track-collections/${id}/keywords`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackCollectionsIdKeywordsQueryKey = (id: number,) => {
    return [
    `/api/v1/track-collections/${id}/keywords`
    ] as const;
    }


export const getGetApiV1TrackCollectionsIdKeywordsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError = ProblemDetails | null>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackCollectionsIdKeywordsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>> = ({ signal }) => getApiV1TrackCollectionsIdKeywords(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackCollectionsIdKeywordsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>>
export type GetApiV1TrackCollectionsIdKeywordsQueryError = ProblemDetails | null


export function useGetApiV1TrackCollectionsIdKeywords<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError = ProblemDetails | null>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsIdKeywords<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsIdKeywords<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackCollectionsIdKeywords<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError = ProblemDetails | null>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsIdKeywords>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackCollectionsIdKeywordsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiV1TrackCollectionsIdKeywords = (
    id: number,
    putTrackCollectionKeywordsRequestBodyNull: PutTrackCollectionKeywordsRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PutTrackCollectionKeywordsResponse | null>(
      {url: `/api/v1/track-collections/${id}/keywords`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putTrackCollectionKeywordsRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1TrackCollectionsIdKeywordsMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdKeywords>>, TError,{id: number;data: PutTrackCollectionKeywordsRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdKeywords>>, TError,{id: number;data: PutTrackCollectionKeywordsRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1TrackCollectionsIdKeywords'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdKeywords>>, {id: number;data: PutTrackCollectionKeywordsRequestBody | null}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV1TrackCollectionsIdKeywords(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1TrackCollectionsIdKeywordsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdKeywords>>>
    export type PutApiV1TrackCollectionsIdKeywordsMutationBody = PutTrackCollectionKeywordsRequestBody | null
    export type PutApiV1TrackCollectionsIdKeywordsMutationError = ProblemDetails | null

    export const usePutApiV1TrackCollectionsIdKeywords = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackCollectionsIdKeywords>>, TError,{id: number;data: PutTrackCollectionKeywordsRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1TrackCollectionsIdKeywords>>,
        TError,
        {id: number;data: PutTrackCollectionKeywordsRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1TrackCollectionsIdKeywordsMutationOptions(options), queryClient);
    }
    export const getApiV1TrackCollectionsPageSlug = (
    slug: string | null,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackCollectionPageResponse | null>(
      {url: `/api/v1/track-collections/page/${slug}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackCollectionsPageSlugQueryKey = (slug: string | null,) => {
    return [
    `/api/v1/track-collections/page/${slug}`
    ] as const;
    }


export const getGetApiV1TrackCollectionsPageSlugQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError = ProblemDetails | null>(slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackCollectionsPageSlugQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>> = ({ signal }) => getApiV1TrackCollectionsPageSlug(slug, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackCollectionsPageSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>>
export type GetApiV1TrackCollectionsPageSlugQueryError = ProblemDetails | null


export function useGetApiV1TrackCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackCollectionsPageSlug>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackCollectionsPageSlugQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






